import React from 'react'
import PropTypes from 'prop-types'

const LeaveClassIcon = ({ className, height, width, ...props }) => (
  <svg
    aria-hidden
    className={className}
    fill="none"
    height={height}
    viewBox="0 0 12.5 10"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.33333 8.66669V10H0V8.66669C0 8.66669 0 6.00002 4.66667 6.00002C9.33333 6.00002 9.33333 8.66669 9.33333 8.66669ZM7 2.33336C7 1.87187 6.86315 1.42074 6.60676 1.03703C6.35037 0.653313 5.98596 0.354244 5.55959 0.177639C5.13323 0.0010346 4.66408 -0.0451732 4.21146 0.044859C3.75883 0.134891 3.34307 0.35712 3.01675 0.683442C2.69043 1.00976 2.4682 1.42552 2.37817 1.87815C2.28814 2.33077 2.33434 2.79992 2.51095 3.22629C2.68755 3.65265 2.98662 4.01706 3.37034 4.27345C3.75405 4.52984 4.20518 4.66669 4.66667 4.66669C5.2855 4.66669 5.879 4.42086 6.31658 3.98327C6.75417 3.54569 7 2.9522 7 2.33336Z"
      fill="currentColor"
    />
    <path d="M8 4.66667H12" stroke="currentColor" strokeLinecap="round" />
  </svg>
)

LeaveClassIcon.propTypes = {
  className: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
}

LeaveClassIcon.defaultProps = {
  height: '10',
  width: '12.5',
}

export default LeaveClassIcon
